export default "__VITE_ASSET__CJ2lTUHb__"